import 'bxcommon/validations/inityup';

import axios from 'axios';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { createRoot } from 'react-dom/client';

import * as common from 'bxcommon/locales/en/common';
import i18n from 'bxcommon/i18n';

import * as en from './locales/en';
import App from './App';

axios.defaults.baseURL = import.meta.env.VITE_BASE_URL;
const translationsUrl = import.meta.env.VITE_BASE_URL + '/translations/{{lng}}/{{ns}}.json';

const bundledResources = {
  en: {
    common: common.default,
    registry: en.default,
  },
};

i18n.init({
  fallbackLng: 'en',
  backend: {
    backends: [HttpBackend, resourcesToBackend(bundledResources)],
    backendOptions: [
      {
        loadPath: translationsUrl,
        crossDomain: true,
        withCredentials: true,
        overrideMimeType: true,
        requestOptions: {
          mode: 'cors',
          credentials: 'same-origin',
          cache: 'default',
        },
      },
      {
        resources: bundledResources,
      },
    ],
  },
  ns: ['common', 'registry'],
  defaultNS: 'registry',
  debug: import.meta.env.VITE_I18N_DEBUG === 'true',
  interpolation: {
    escapeValue: false,
  },
});

createRoot(document.getElementById('root')).render(<App />);
